import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputBase from 'components/InputBase';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';

const StyledSelect = styled.select`
  outline: none;
  -webkit-appearance: none;
  border-radius: 0;
  background-color: transparent;
  border: none;
  border-bottom: ${({ error, theme }) => (error ? theme.palette.input.error : theme.palette.input.text)} solid 2px;
  padding-bottom: ${({ theme }) => theme.spacing}px;
  padding-right: 2rem;
  margin-right: -1rem;
  margin-top:${({ theme }) => theme.spacing}px;
  font-size: 1.5rem;

  /* IE11 */
  &::-ms-expand {
    display: none;
  }
  &:focus {
    border-bottom-color: ${({ theme }) => theme.palette.input.focus};
  }
`;

const StyledInputBase = styled(InputBase)`
  .input-field {
    align-items: center;
  }

  .expandIcon {
    pointer-events: none;
  }

`;

const Select = ({
  name, label, placeholder, options, value, onChange, error, disabled, className, focus, ...rest
}) => {
  const classes = ['Select'];
  if (className) {
    classes.push(className);
  }

  return (
    <StyledInputBase label={label} className={classes.join(' ')} error={error} {...rest}>
      <StyledSelect
        onChange={onChange}
        value={value}
        name={name}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </StyledSelect>
      <FontAwesomeIcon className="expandIcon" icon={faAngleDown} />
    </StyledInputBase>
  );
};

Select.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  focus: PropTypes.bool,
};

Select.defaultProps = {
  placeholder: '',
  name: null,
  value: undefined,
  onChange: null,
  error: null,
  disabled: false,
  className: null,
  focus: false,
};

export default Select;
